import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=b59657ec&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=b59657ec&prod&scoped=true&lang=css"
import style1 from "./Detail.vue?vue&type=style&index=1&id=b59657ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59657ec",
  null
  
)

export default component.exports